<template>
    <tbody :key="'tbody_1'">
    <template v-if="isQuote">
        <tr v-for="(product, index) in products" :key="'q_s_'+index + '_'+product.quote_product_id" :id="'q_s_'+index + '_'+product.quote_product_id" class="product-table-item active-row">
            <template v-if="product.quote_product_id">
                <td>
                    <div class="custom-control custom-checkbox">
                        <input :value="product.quote_product_id" type="checkbox" class="custom-control-input"
                               :id="'id_' +index"
                               :name="'id_' +index"
                               :checked="true"
                               v-on:click="removeProductCheckbox(product, $event)"/>
                        <label class="custom-control-label" :for="'id_' +index"><i class="fa fa-flag"
                                                                                   aria-hidden="true"></i></label>
                    </div>
                </td>
                <td>
                    <template v-if="product.quotation">
                        #{{ product.quotation.quotation_number }}
                    </template>
                </td>
                <td>
                    <template v-if="product.product_id">

                        <input readonly type="text" class="form-control form-custom" placeholder="Item#"
                               v-model="products[index].product_num"/>
                    </template>
                    <template v-if="!product.product_id">
                        <ValidationProvider name="Quantity" immediate rules="required"
                                            v-slot="{ errors }">
                            <input type="text" class="form-control form-custom" placeholder="Item#"
                                   v-model="products[index].product_num"/>
                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                        </ValidationProvider>
                    </template>

                </td>
                <td>
                    <input v-model="products[index].product_name" type="text"
                           class="form-control form-custom mb-1" placeholder="">
                    <!-- <ckeditor v-model="products[index].product_desc"
                              :key="'editor_' + index + '_' + product.product_id"
                               :id="'editor_' + index + '_' + product.product_id"
                              type="inline"
                              :config="editorConfigMin"></ckeditor> -->

                                <!-- <textarea v-model="products[index].product_desc"></textarea> -->

                                <vue-editor
                                :id="'editor_' + index + '_' + product.quote_product_id"
                                useCustomImageHandler
                                @image-added="handleImageAdded"
                                v-model="products[index].product_desc"
                                :editorToolbar="editorOptions"
                                >
                                </vue-editor>
                              <!-- <ckeditor
                           
                        :value="products[index].product_desc"
                        @instanceReady="onEditorReady($event, 0)"
                        :name="'editor_' + index + '_' + product.quote_product_id"
                        :id="'editor_' + index + '_' + product.quote_product_id"
                        :key="'editor_' + index + '_' + product.quote_product_id"
                        :config="editorConfigMin"
                        ></ckeditor> -->


                </td>
                <td>
                    <template v-if="product.quotation_price_detail.length > 1">
                        <ul class="quote-list-group">
                            <li class="list-group-item" v-for="(tier, tierIndex) in product.quotation_price_detail">
                                <div class="input-group">
                                    <input type="text" class="form-control form-custom" placeholder=""
                                           v-on:keydown="checkNumber($event)"
                                           :readonly="product.quote_tier_id != tier.id"
                                           @input="tierPeicesChange(product, tier, index, tierIndex, $event)"
                                           v-model="products[index].quotation_price_detail[tierIndex].peices">
                                    <div class="input-group-append">
                                        <input :value="product.quote_product_id" type="checkbox" class="form-control"
                                               :id="'tier_' +index+ '_'+tierIndex"
                                               :name="'tier_' +index"
                                               :checked="product.quote_tier_id == tier.id"
                                               v-on:click="selectProductTierCheckbox(product, tier, index, tierIndex, $event)"/>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </template>
                    <template v-if="product.quotation_price_detail.length <= 1">
                        <ValidationProvider name="Quantity" immediate rules="required|positive|min_value:0"
                                            v-slot="{ errors }">
                            <input type="text" class="form-control form-custom" placeholder=""
                                   v-on:keydown="checkNumber($event)"
                                   v-model="products[index].qty">
                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                        </ValidationProvider>
                    </template>
                </td>
                <td>
                    <ValidationProvider name="Quantity unit" rules="required" v-slot="{ errors }">
                        <select class="form-control" v-model="products[index].qty_unit_id">
                            <option value="">Select</option>
                            <option v-for="(qtyUnit, unitIndex) in quantityUnits" :value="qtyUnit.id">
                                {{ qtyUnit.name }}
                            </option>
                        </select>
                        <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                    </ValidationProvider>
                </td>
                <td>
                    <ValidationProvider name="Price" rules="required|positive|min_value:0"
                                        v-slot="{ errors }">
                        <input type="text" class="form-control form-custom dollar-prefix" placeholder=""
                               v-on:keydown="checkDecimal($event, this)"
                               v-model="products[index].price">
                        <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                    </ValidationProvider>
                </td>
                <td><span class="status"> </span></td>
            </template>
        </tr>
    </template>
    <template v-else>
        <tr v-for="(product, index) in products" :key="'p_s_selected_'+product.product_id+'_'+index" :id="'p_s_'+product.product_id" class="product-table-item active-row">
            <template v-if="!product.quote_product_id">
                <td>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input"
                               :value="product.product_id"
                               :id="'id_' +index"
                               name="s_prod_ids[]"
                               :checked="true"
                               @click="removeProductCheckbox(product, $event)">
                        <label class="custom-control-label" :for="'id_' +index"></label>
                    </div>
                </td>
                <td>
                    <input type="hidden" readonly class="form-control form-custom" placeholder="Item#"
                           v-model="products[index].product_num"/>
                    <router-link :to="{ name: 'productsDetails', params: { id: product.product_id }}" target="_blank">{{ product.product_num }}</router-link>
                </td>
                <td>
                    <input v-model="products[index].product_name" type="text"
                           class="form-control form-custom mb-1" placeholder="">
                           <!-- <textarea v-model="products[index].product_desc"></textarea> -->

                           <vue-editor
                                :id="'editor_' + index + '_' + product.product_id"
                                useCustomImageHandler
                                @image-added="handleImageAdded"
                                v-model="products[index].product_desc"
                                :editorToolbar="editorOptions"
                                >
                                </vue-editor>

                           <!-- <ckeditor
                           @input="selectEditorData($event,index)"
                        v-model="products[index].product_desc"
                        :name="'editor_' + index + '_' + product.product_id"
                        :id="'editor_' + index + '_' + product.product_id"
                        :key="'editor_' + index + '_' + product.product_id"
                        :config="editorConfigMin"
                        ></ckeditor> -->

                    <!-- <ckeditor v-model="products[index].product_desc"
                              type="inline"
                              :config="editorConfigMin"></ckeditor> -->
                </td>
                <td>
                    <ValidationProvider name="Quantity" immediate rules="required|positive|min_value:0"
                                        v-slot="{ errors }">
                        <input type="text" class="form-control form-custom" placeholder=""
                               v-on:keydown="checkNumber($event)"
                               v-model="products[index].qty">
                        <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                    </ValidationProvider>
                </td>
                <td>
                    <ValidationProvider name="Quantity unit" rules="required" v-slot="{ errors }">
                        <select class="form-control" v-model="products[index].qty_unit_id">
                            <option value="">Select</option>
                            <option v-for="(qtyUnit, unitIndex) in quantityUnits" :value="qtyUnit.id">
                                {{ qtyUnit.name }}
                            </option>
                        </select>
                        <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                    </ValidationProvider>
                </td>
                <td>
                    <ValidationProvider name="Price" rules="required|positive|min_value:0"
                                        v-slot="{ errors }">
                        <input type="text" class="form-control form-custom dollar-prefix" placeholder=""
                               v-on:keydown="checkDecimal($event, this)"
                               v-model="products[index].price">
                        <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                    </ValidationProvider>
                </td>
                <td>
                    <template v-if="product.latest_order">
                        <router-link :to="{ name: 'orderShow', params: { id: product.latest_order.id }}" target="_blank">#{{product.latest_order.order_number}}</router-link>
                    </template>
                </td>
                <!--<td>
                    <ValidationProvider name="Cost" rules="required|positive|min_value:0"
                                        v-slot="{ errors }">
                        <input type="text" class="form-control form-custom dollar-prefix" placeholder="2.0"
                               v-on:keydown="checkDecimal($event, this)"
                               v-model="products[index].vendor_cost">
                        <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                    </ValidationProvider>
                </td>-->
                <td>{{ getVendorName(product) }}</td>
            </template>

        </tr>
    </template>

    </tbody>

</template>

<script>
import {ValidationProvider, ValidationObserver} from 'vee-validate';
import { VueEditor } from "vue2-editor";

export default {
    name: "SelectedProducts",
    components: {
        ValidationProvider, ValidationObserver,VueEditor
    },
    props: ['selectedProducts', 'bus', 'quantityUnits', 'products', 'productData', 'isQuote'],
    created() {
    },
    mounted() {

    },
    data() {
        return {
            editorConfig: {},
            editorConfigMin: {
                toolbar: []
            },
            editorOptions: []
        }
    },
    methods: {
        onEditorReady(event, index) {
            console.log('Editor initialized for index:', index);
            const editor = event.editor;

            editor.removeAllListeners('change');

            editor.on('change', () => {
                const data = editor.getData();
                this.$set(this.products[index], 'product_desc', data);
            });
        },

        selectEditorData(data,index){
            alert(data);
            alert(index);
        },
        getQuantityUnitName(id) {
            if (id != null) {
                let unit = this.quantityUnits.find((x) => x.id == id);
                if (unit) {
                    return unit.name;
                }
            }
            return '';
        },
        tierPeicesChange(product, tier, index, tierIndex, event){
            this.products[index].qty = tier.peices;
        },
        selectProductTierCheckbox(product, tier, index, tierIndex, event){
            this.products[index].quote_tier_id = tier.id;
            this.products[index].qty = tier.peices;
            //this.products[index].price = tier.price;
            this.products[index].price = tier.selling ? tier.selling : 0;
        },
        getVendorName(product) {
            let vendor = this.getVendorFromProduct(product);
            if (vendor) {
                return vendor.company_name;
            }
            return null;
        },
        getVendorId(product) {
            let vendor = this.getVendorFromProduct(product);
            if (vendor) {
                return vendor.id;
            }
            return null;
        },
        getVendorFromProduct(product) {
            if (product.vendor) {
                return product.vendor;
            } else if (product.quotation_products) {
                let vendor = null;
                product.quotation_products.forEach((qp) => {
                    if (qp.quotation_prices && vendor == null) {
                        qp.quotation_prices.forEach((qpp) => {
                            if (qpp.vendor && vendor == null) {
                                vendor = _.cloneDeep(qpp.vendor);
                            }
                        })
                    }
                });
                return vendor;
            }
            return null;
        },
        removeProductCheckbox(c, event) {
            this.$emit('removeProductCheckbox', {c: c, checked: false});
        },
        getSLNo(index) {
            return Number(this.productData.config['start_from']) + index;
        },
        updateProducts(products) {
            /*let updatedProducts = [];
            if(this.isQuote) {
                updatedProducts = products.filter((x) => this.selectedProducts.filter((y) => y == x.quote_product_id).length > 0);
            } else {
                updatedProducts = products.filter((x) => this.selectedProducts.filter((y) => y == x.product_id).length > 0);
            }*/
            this.$emit('watchChangedProducts', products);
        },
    },
    watch: {
        "products": {
            handler: function (after, before) {
                after.forEach((x, index) => {
                    console.log("xindex",index);
                    console.log("x",x);
                    this.products[index].unit_price = this.strAmountToNumber(x.price);
                    let sum = this.strAmountToNumber(x.price) * x.qty;
                    if (!isNaN(sum)) {
                        this.products[index].cost = sum;
                        after[index].cost = sum;
                    }

                });
                //this.updateProducts(after);
            },
            deep: true,
        },
    },
    computed: {

    }
}
</script>

<style scoped>
.error {
    color: red;
}
.product-list-item {
    transition: all 1s;
}
.product-list-enter,
.product-list-leave-to {
    max-height: 0px;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    overflow: hidden;
}
.product-list-enter-to,
.product-list-leave {
    max-height: 80px;
}

.product-table-item {
    transition: all 1s;
}
.product-table-item > * {
    transition: all 1s;
    overflow: hidden;
}
.product-table-enter,
.product-table-leave-to {
    line-height: 0;
}
.product-table-enter > *,
.product-table-leave-to > * {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
}
.product-table-enter-to,
.product-table-leave {
    line-height: 1.5;
}
.inner-wrapper .quillWrapper .ql-snow.ql-toolbar {
display: none !important;
}
</style>
